import { reactive, onMounted, watch } from "vue"

import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel"
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard"
import Locale from "@/helper/locale/Locale"

export default function useDashboardComposable(config, emit) {
    const states = reactive({
        items: [],
        isLoading: false,
        builder: new SubDashboardConfigBuilder(),
        error: null
    })
    states.builder.setLocale(Locale.getLocaleCode());

    // reuse by receive dashboard config name
    /**
     *
     * @param {*} [configName=]
     * @returns {Promise}
     */
    const apiGetDashboard = function (configName = null) {
        let cfgName = config
        if (configName != null) {
            cfgName = configName
        }

        states.isLoading = true

        return new Promise((resolve, reject) => {
            var params = states.builder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, cfgName).subscribe({
                next: (data) => {
                    states.isLoading = false
                    states.items = data

                    states.error = null
                    resolve(states.items)
                },
                error: (err) => {
                    states.isLoading = false
                    states.items = []

                    states.error = err
                    reject(err)
                    emit("onError", err)
                }
            })
        })
    }

    watch(() => states.isLoading, (val) => {
        // console.log("watch state", val)
        if (val) {
            emit("onLoading")
        } else {
            emit("onLoaded")
        }
    })

    onMounted(apiGetDashboard)

    return {
        states,
        apiGetDashboard
    }
}
